{
  "close": "Bezárás"
}
